import type { Organisation } from '@esf/shared';

export const demoOrganisations: Organisation[] = [
  {
    id: 'ORG-001',
    name: 'Bristol City Council',
    slug: 'bristol-city-council',
    contactEmail: 'assets@bristol.gov.uk',
    contactPhone: '+44 117 922 2000',
    address: 'City Hall, College Green, Bristol BS1 5TR',
    isEsfOrg: false,
    enabled: true,
    tier: 'enterprise',
    maxUsers: 50,
    createdAt: '2024-01-15T09:00:00.000Z',
    updatedAt: '2025-11-20T14:30:00.000Z',
  },
  {
    id: 'ORG-002',
    name: 'Bath & North East Somerset Council',
    slug: 'banes-council',
    contactEmail: 'streetscene@bathnes.gov.uk',
    contactPhone: '+44 1225 477000',
    address: 'Lewis House, Manvers Street, Bath BA1 1JG',
    isEsfOrg: false,
    enabled: true,
    tier: 'standard',
    maxUsers: 20,
    createdAt: '2024-03-10T10:00:00.000Z',
    updatedAt: '2025-09-05T11:15:00.000Z',
  },
  {
    id: 'ORG-003',
    name: 'South Gloucestershire Council',
    slug: 'south-glos-council',
    contactEmail: 'streetcare@southglos.gov.uk',
    contactPhone: '+44 1454 868009',
    address: 'Badminton Road, Yate, Bristol BS37 5AF',
    isEsfOrg: false,
    enabled: true,
    tier: 'free',
    maxUsers: 5,
    createdAt: '2024-06-01T08:30:00.000Z',
    updatedAt: '2025-08-12T09:45:00.000Z',
  },
];
